/* eslint-disable import/no-named-as-default */
import { ReactElement } from 'react'
import { getCorrelationID } from 'helpers/requestParams'
import { generateTransId } from 'syf-js-utilities/helpers'
import Transmit from 'syf-transmit-mfe'
import {
  ApplicationId,
  ChannelId,
  CommercialAppParams,
  FlowId,
  LanguageType,
  TransmitProps,
  TransmitResponse
} from 'syf-transmit-mfe/dist/typings/transmit'
import { clientInfo } from 'configureBrand'
import config from 'const/config'
import TransmitMock from 'ui/organisms/TransmitMock'
import useTransmitMock from 'ui/customHooks/useTransmitMock'

const LANGUAGE: LanguageType = 'en'
const CHANNEL_ID: ChannelId = 'cml'
const APPLICATION_ID: ApplicationId = 'commercialwebapp'

export interface TransmitMfaProps {
  userId: TransmitProps['userId']
  flow: FlowId
  jwtToken: string
  onTransmitResponse: TransmitProps['handleResponse']
}

const TransmitMFA = ({
  userId,
  flow,
  jwtToken,
  onTransmitResponse
}: TransmitMfaProps): ReactElement => {
  const mockTransmit = useTransmitMock()
  /**
   * Handler to get the response
   */
  const responseHandler: TransmitProps['handleResponse'] = (
    response: TransmitResponse
  ) => {
    onTransmitResponse(response)
  }

  // params required for the userParams prop
  const userParams: CommercialAppParams = {
    header: {
      channel_id: CHANNEL_ID,
      client_id: clientInfo.clientName,
      trans_id: generateTransId()
    },
    flow_id: flow,
    jwt: jwtToken,
    language_code: 'en',
    correlation_id: getCorrelationID()
  }

  if (mockTransmit) {
    // return the mock transmit component
    return (
      <TransmitMock
        language={LANGUAGE}
        handleResponse={responseHandler}
        applicationId={APPLICATION_ID}
        apiHost={config.transmitApiHost}
        sdkEnv={config.transmitEnv}
        assetHost={config.transmitAssetHost}
        userId={userId}
        userParams={userParams}
      />
    )
  }

  return (
    <Transmit
      language={LANGUAGE}
      handleResponse={responseHandler}
      applicationId={APPLICATION_ID}
      apiHost={config.transmitApiHost}
      sdkEnv={config.transmitEnv}
      assetHost={config.transmitAssetHost}
      userId={userId}
      userParams={userParams}
    />
  )
}

export default TransmitMFA
